import React from 'react';
import { Row } from 'react-bootstrap';
import { Section } from '../section';
import { DescriptionItem } from '../description-item';
import { ProtectionInfo } from '../../common';
import { useTranslation } from 'react-i18next';

export const Protection: React.FC = () => {
    const { t } = useTranslation();

    return(
    <Section
        id="sec-protection"
        title={t('protect.title')}
        color="color-1"
        wrapper
    >
        <Row className="features">
            {ProtectionInfo.map((item, key) => (
                <DescriptionItem
                    path={item.path}
                    md={4}
                    sm={4}
                    xs={12}
                    title={t(item.title)}
                    imageClass="text-center"
                    key={key}
                >
                    <ul>
                        {item.lines!.map((line, key) => (
                            <li key={key}>{t(line)}</li>
                        ))}
                    </ul>
                </DescriptionItem>
            ))}
        </Row>
    </Section>
    )};
